import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import styles from "./styles.css"

import { useTimeout } from "hooks/useTimeout"

const ToastContainer = ({ id, message, onClose, onExit, type = "success" }) => {
  const listTypes = {
    success: styles["toast--green"],
    error: styles["toast--error"]
  }

  useTimeout(
    () => {
      onClose()
      onExit()
    },
    3000,
    [onClose, onExit]
  )

  return (
    <div id={id} className={classNames(styles.toast, listTypes[type])}>
      <div className={styles.toast__content}>
        <p className={styles.toast__type}>Info</p>
        <p className={styles.toast__message}>{message}</p>
      </div>
    </div>
  )
}

ToastContainer.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  message: PropTypes.string,
  onExit: PropTypes.func,
  onClose: PropTypes.func
}

export default ToastContainer



// WEBPACK FOOTER //
// ./src/components/Toast/v1/index.js